import { Outlet } from '@tanstack/react-router'
import { Header } from '../components/Header/Header'
import { Footer } from '../components/Footer/Footer'

export function RootLayout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  )
}
